var map = {
	"./Base": 732,
	"./Base/": 732,
	"./Base/index": 732,
	"./Base/index.js": 732,
	"./Base/style": 179,
	"./Base/style.js": 179,
	"./Clutch": 429,
	"./Clutch/": 429,
	"./Clutch/index": 429,
	"./Clutch/index.js": 429,
	"./Clutch/renderComponent": 1637,
	"./Clutch/renderComponent.js": 1637,
	"./Clutch/style": 1295,
	"./Clutch/style.js": 1295,
	"./NewUi": 1017,
	"./NewUi/": 1017,
	"./NewUi/index": 1017,
	"./NewUi/index.js": 1017,
	"./NewUi/style": 1296,
	"./NewUi/style.js": 1296,
	"./OldUi": 1018,
	"./OldUi/": 1018,
	"./OldUi/index": 1018,
	"./OldUi/index.js": 1018,
	"./OldUi/renderComponent": 1638,
	"./OldUi/renderComponent.js": 1638,
	"./OldUi/style": 1297,
	"./OldUi/style.js": 1297,
	"./SpireonNew": 1019,
	"./SpireonNew/": 1019,
	"./SpireonNew/index": 1019,
	"./SpireonNew/index.js": 1019,
	"./SpireonNew/renderComponent": 1639,
	"./SpireonNew/renderComponent.js": 1639,
	"./SpireonNew/style": 1298,
	"./SpireonNew/style.js": 1298,
	"./SpireonOld": 1020,
	"./SpireonOld/": 1020,
	"./SpireonOld/index": 1020,
	"./SpireonOld/index.js": 1020,
	"./SpireonOld/renderComponent": 1640,
	"./SpireonOld/renderComponent.js": 1640,
	"./SpireonOld/style": 1299,
	"./SpireonOld/style.js": 1299
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87;